import React from 'react'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import ProcedureImage from './ProcedureImage'
import ProcedureText from './ProcedureText'
import ProcedureOb from './ProcedureOb'

const Procedure = () => {
  return (
    <>
         <ProcedureImage/>
         <ProcedureText/>
         <ProcedureOb/>
        <Scroll/>
        <Footer/>
    </>
  )
}

export default Procedure
